import { ArrowForwardIos } from '@interhyp/platform-icons';
import classnames from 'classnames';
import React from 'react';
import { BaseSwiper, BaseSwiperContainer } from "./components/BaseSwiper/BaseSwiper.js";
import styles from "./Swiper.module.js";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export function Swiper({
  sizeSettings = {
    xs: {
      slidesPerView: 1,
      slidesPerGroup: 1
    },
    sm: {
      slidesPerView: 2,
      slidesPerGroup: 2
    },
    md: {
      slidesPerView: 3,
      slidesPerGroup: 2
    },
    lg: {
      slidesPerView: 4,
      slidesPerGroup: 2
    }
  },
  breakpoints = {
    sm: 768,
    md: 992,
    lg: 1600
  },
  className,
  uniqueId,
  prevButtonClassName,
  nextButtonClassName,
  ...props
}) {
  const swiperBreakpoints = {};
  Object.entries(breakpoints).forEach(([key, value]) => {
    const sizeSetting = sizeSettings[key];
    if (sizeSetting) {
      swiperBreakpoints[value] = sizeSetting;
    }
  });
  return /*#__PURE__*/_jsxs(BaseSwiperContainer, {
    className: className,
    children: [/*#__PURE__*/_jsx("div", {
      className: classnames(styles.navigationArrow, styles.prev, `swiperPrev-${uniqueId}`, prevButtonClassName),
      children: /*#__PURE__*/_jsx(ArrowForwardIos, {})
    }), /*#__PURE__*/_jsx(BaseSwiper, {
      ...props,
      swiperProps: {
        slidesPerView: sizeSettings.xs.slidesPerView,
        slidesPerGroup: sizeSettings.xs.slidesPerGroup,
        breakpoints: swiperBreakpoints,
        navigation: {
          disabledClass: styles.disabled,
          prevEl: `.swiperPrev-${uniqueId}`,
          nextEl: `.swiperNext-${uniqueId}`
        },
        pagination: {
          clickable: true,
          el: `.${styles.paginationContainer}`
        }
      },
      children: /*#__PURE__*/_jsx("div", {
        slot: "container-end",
        className: styles.paginationContainer
      })
    }), /*#__PURE__*/_jsx("div", {
      className: classnames(styles.navigationArrow, styles.next, `swiperNext-${uniqueId}`, nextButtonClassName),
      children: /*#__PURE__*/_jsx(ArrowForwardIos, {})
    })]
  });
}